import { useEffect, useRef } from 'react';
import { navAutoCollapseWidthV3 } from './NavigationV3.js';
export const useNavigationResize = ({ collapsed, handleCollapse }) => {
    const previousWidth = useRef(window.innerWidth);
    useEffect(() => {
        function navigationResizeHandler() {
            if (!collapsed && previousWidth.current > navAutoCollapseWidthV3 && window.innerWidth <= navAutoCollapseWidthV3) {
                handleCollapse();
            }
            previousWidth.current = window.innerWidth;
        }
        window.addEventListener('resize', navigationResizeHandler);
        return () => window.removeEventListener('resize', navigationResizeHandler);
    }, [collapsed, handleCollapse]);
};
//# sourceMappingURL=useNavigationResize.js.map